import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';


const columns = [
  {
    title: 'Reference',
    dataIndex: 'number', 
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Vendor',
    dataIndex: 'vendor',
    key: 'vendor',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Order Date',
    dataIndex: 'order_deadline_date',
    key: 'order_deadline_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.order_deadline_date).toLocaleDateString()} {new Date(record.order_deadline_date).toLocaleTimeString()}</span>
  },
  {
    title: 'Expected Arrival',
    dataIndex: 'expected_arrival_date',
    key: 'expected_arrival_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.expected_arrival_date).toLocaleDateString()} {new Date(record.expected_arrival_date).toLocaleTimeString()}</span>
  },
  {
    title: 'Source Document',
    dataIndex: 'source_document',
    key: 'source_document',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Total',
    dataIndex: 'total',
    key: 'total',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>GHc {record.total}</span>
  },
  {
    title: 'Total Received',
    dataIndex: 'received_total',
    key: 'received_total',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>GHc {record.received_total}</span>
  },
  {
    title: 'Status',
    dataIndex: 'status', 
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'RFQ' ? "text-blue-400 bg-blue-100 w-max" : record.status === 'RECEIVED' ? "text-green-600 bg-green-100 w-max" : record.status === 'PURCHASE ORDER' ? "text-[#189aa0] bg-[#61edf2] w-max" : "text-red-950 bg-red-100 w-max"}>{record.status}</Badge>
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/purchase/request-for-quotation/'+record.number.replaceAll('/', '-')}>
        EDIT
      </Link>
    )
  }
]



const RequestForQuotations = () => {
  const rfqs = useLoaderData();
  const navigate = useNavigate();
  const { CustomBreadcrumb } = useOutletContext();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/purchase/request-for-quotation/'+record.number.replaceAll('/', '-'))
    };
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><CustomBreadcrumb /></h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
          <Button className='' size={'sm'}>
            <Link to={'/purchase/request-for-quotation/new'} className='w-full'>New</Link>
          </Button>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={rfqs}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
        rowKey={'number'}
      />
    
    </div>
  )
}

export default RequestForQuotations;